import {z} from 'zod'
import {PRICE_REGEX} from '../../utils/price.js'

// The format prices were validated with before they always had two decimals: '', '5', '5,', '5,5', ',5' and '-'
const LEGACY_PRICE_REGEX = /^-?[0-9]{0,5}(,[0-9]{0,2})?$/

/**
 * Brings a price stored in the legacy format to the stored format ('5' -> '5,00', '5,5' -> '5,50', '' -> '0,00'), so
 * records saved before still validate and are stored in the new format on their next save. Anything else (a price
 * with a decimal point, text, 'priceScale') is returned as it is and left to the validation.
 */
export function normalizeLegacyPrice(value: unknown): unknown {
    if (typeof value !== 'string' || !LEGACY_PRICE_REGEX.test(value)) {
        return value
    }

    const negative = value.startsWith('-')
    const [whole, decimals = ''] = value.replace('-', '').split(',')

    if (!whole && !decimals) {
        return '0,00'
    }

    const price = `${whole || '0'},${decimals.padEnd(2, '0')}`

    return negative && price !== '0,00' ? `-${price}` : price
}

/** A stored price, '12,50'. A price in the legacy format is converted first. */
export const Price = z.preprocess(normalizeLegacyPrice, z.string().regex(PRICE_REGEX))

/** A stored price or '' (not set). A price in the legacy format is converted first, '' stays ''. */
export const PriceOrEmpty = z.preprocess((value) => value === '' ? '' : normalizeLegacyPrice(value), z.string().regex(PRICE_REGEX).or(z.literal('')))
